import React from 'react';
import { useTranslation } from 'react-i18next';
import { mergeConversationProgress } from '../utilities/conversationProgress';
import './ConversationProgress.css';

const ConversationProgressSummary = ({ conversationProgress, title = null }) => {
  const { t } = useTranslation();
  const progress = mergeConversationProgress(conversationProgress);
  if (!progress) return null;

  return (
    <section className="conversation-progress-summary" aria-labelledby="conversation-progress-summary-title">
      <h3 id="conversation-progress-summary-title">{title || t('conversation_summary_title')}</h3>
      <div className="conversation-progress-summary__columns">
        <div>
          <h4>{t('conversation_top_errors')}</h4>
          {progress.errors.length > 0 ? (
            <ol>
              {progress.errors.map(error => (
                <li key={`${error.text}-${error.correction}`}>
                  <span className="conversation-highlight conversation-highlight--error">{error.text}</span>
                  <span className="conversation-progress-summary__arrow" aria-hidden="true">→</span>
                  <span className="conversation-highlight conversation-highlight--correction">{error.correction}</span>
                  {error.explanation && <small>{error.explanation}</small>}
                </li>
              ))}
            </ol>
          ) : <p>{t('conversation_no_errors')}</p>}
        </div>
        <div>
          <h4>{t('conversation_top_concepts')}</h4>
          {progress.acquiredConcepts.length > 0 ? (
            <ol>
              {progress.acquiredConcepts.map(concept => (
                <li key={concept.concept}>
                  <span className={`conversation-highlight conversation-highlight--${concept.status}`}>{concept.concept}</span>
                  <small>{concept.status === 'reviewed'
                    ? t('conversation_reviewed_marker')
                    : t('conversation_learned_marker')}
                  </small>
                </li>
              ))}
            </ol>
          ) : <p>{t('conversation_no_concepts')}</p>}
        </div>
      </div>
    </section>
  );
};

export default ConversationProgressSummary;
